import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=4854d8d8&scoped=true&"
import script from "./ProductList.vue?vue&type=script&lang=ts&"
export * from "./ProductList.vue?vue&type=script&lang=ts&"
import style0 from "./ProductList.vue?vue&type=style&index=0&id=4854d8d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4854d8d8",
  null
  
)

export default component.exports